<script setup lang="ts">
import { computed, ref, withDefaults } from 'vue';

import Core from '@/core/core/core';
import { nl2br } from '@/core/utils/string';

import type { Emits, Props } from './types';
import { prepareText, transitionDuration } from '@/components/core/notice/utils';

const props = withDefaults(defineProps<Props>(), {
	selectToClose: true,
});

const emit = defineEmits<Emits>();

// анимация появления
const showed = ref(false);
setTimeout(() => showed.value = true, 10);

// анимация закрытия
const closed = ref(false);
const closedDirection = ref<'top' | 'right' | 'bottom' | 'left'>('right');

const title = computed(() => {
	let res = props.title.replace(/ {2}/g, '&nbsp;');

	if (!props.isSafeHTML) res = prepareText(res);

	return res;
});

const text = computed(() => {
	let res = nl2br(props.text);

	res = res.replace(/ {2}/g, '&nbsp;');

	if (!props.isSafeHTML) res = prepareText(res);

	return res;
});

const close = (direction?: typeof closedDirection.value) => {
	closed.value = true;

	if (direction) {
		closedDirection.value = direction;
	}

	setTimeout(() => emit('close'), transitionDuration);
};

const onClick = (e: MouseEvent) => {
	if (!props.selectToClose) return;

	const { tagName } = e.target as HTMLElement;

	if (tagName === 'A') close();
	if (tagName === 'BUTTON') close();
};

const vSwipe = {
	mounted: (el: HTMLElement) => {
		if (!Core.state.isMobile) return;

		if (!Core.$ || !Core.$.ui['draggable']) return;

		let direction: typeof closedDirection.value = 'right';

		let axis = 'x';
		// if (getOS() === 'iOS') axis = 'y';

		Core.$(el).draggable({
			revert: false,
			axis,
			drag: (_e, ui) => {
				if (axis == 'x') {
					direction = ui.position.left > 0 ? 'right' : 'left';
				} else {
					direction = ui.position.top > 0 ? 'bottom' : 'top';
				}
			},
			stop: (_e, _ui) => {
				close(direction);
			},
		});
	},
};

// const vSwipe = {
// 	mounted: (el: HTMLElement) => {
// 		const { distanceX, direction } = usePointerSwipe(el, {
// 			disableTextSelect: true,
// 			onSwipe(e: PointerEvent) {
// 				left.value = -distanceX.value + 'px';
// 			},
// 			onSwipeEnd: (_e, direction) => {
// 				close(direction);
// 			},
// 		});
// 	},
// };
</script>

<template>
	<div
		class="top-notice_item"
		:class="{
			['top-notice_item-' + style]: true,
			'top-notice_item-hightlight': hightlight,
			'top-notice_item-showed': showed,
			'top-notice_item-closed': closed || forceClosed,
			['top-notice_item-closed_' + closedDirection]: closed,
		}"
		@click="onClick"
		v-swipe
	>
		<div class="top-notice_itemTextWrapper">
			<div v-if="title" class="top-notice_itemTitle" v-html="title"></div>
			<div v-if="text" class="top-notice_itemText" v-html="text"></div>
		</div>

		<TopButton
			v-if="buttonProps"
			class="top-notice_itemButton"
			size="s"
			:="buttonProps"
			:title="buttonProps.title"
			v-html="buttonProps.default"
			@click="close()"
		/>

		<div
			v-if="buttonsProps?.length"
			class="top-notice_itemButtons"
		>
			<TopButton
				v-for="buttonProps in buttonsProps"
				class="top-notice_itemButton"
				size="s"
				:="buttonProps"
				:title="buttonProps.title"
				v-html="buttonProps.default"
				@click="close()"
			/>
		</div>

		<div v-if="metaText" class="top-notice_itemMetaText" v-html="metaText"></div>

		<div
			class="top-notice_itemClose"
			data-top-icon=""
			:title="$i18n.Common.Close"
			@click="() => close()"
		></div>
	</div>
</template>

<style>
@import "style.css";
</style>
